import React from 'react';
import { SmallText } from 'ds/components/typography';
import { TableColumn } from 'ds/components/table';
import { HpdViolation } from 'store/state/selectors/insights/summaryTypes';
import { ViolationTableColumn } from '../styled';
import { SeverityIndicator } from './SeverityColumn';
import styled from '@emotion/styled';
import { ColumnRendererProps } from 'components/widget/prices/prices-table/utils';

const SeverityInfo = styled.div`
  margin-top: 8px;
  height: 20px;
  display: flex;
  align-items: center;
`;

export const getTypeColumnConfig = (isMobile: boolean): Partial<TableColumn<HpdViolation>> => ({
  sortFn: (items: HpdViolation[]) => items.sort((a, b) => b.category.localeCompare(a.category)),
  width: isMobile ? '50%' : '40%',
  gap: isMobile ? 0 : 16,
  renderFn: (item) => <TypeColumn isMobile={isMobile} item={item} />,
});

export const TypeColumn: React.FC<ColumnRendererProps<HpdViolation>> = ({ item, isMobile }) => {
  return (
    <ViolationTableColumn>
      <SmallText style={{ textTransform: 'capitalize' }}>
        {item.category}
      </SmallText>
      {isMobile ? (
        <SeverityInfo>
          <SeverityIndicator severity={item.severity} />
        </SeverityInfo>
      ) : null}
    </ViolationTableColumn>
  );
};
